module.exports = __webpack_public_path__ + "img/Speaker=Phoenix Normand.e0cb84f3.png";